<h1 mat-dialog-title>Escolha o tipo de impressão</h1>
<mat-divider></mat-divider>
<div mat-dialog-content style="width: 350px;">
    <div class="row mt-4">
        <div class="col-sm">
            <button mat-stroked-button color="primary" (click)="imprimir('Resumida')">
                <mat-icon>print</mat-icon> Resumida
            </button>
        </div>
        <div class="col-sm">
            <button mat-stroked-button color="primary" (click)="imprimir('Completa')">
                <mat-icon>print</mat-icon> Completa
            </button>
        </div>
    </div>
</div>